module.exports = __webpack_public_path__ + "images/original/missing.png";